//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'hopePageProductSlider',
  props: {
    products: {
      required: true,
    },
    title: {
      required: true,
    },
    titleColor: {
      default: '#000000',
    },
    borderColor: {
      default: '#000000',
    },
    productLink:{
      required: true
    }
  },
  methods: {
    joinWithAnd(arr) {
      if ( Array.isArray(arr) === false || arr.length === 0) return '';
      if (arr.length === 1) return arr[0];

      const lastItem = arr.pop();
      return arr.join(', ') + ' and ' + lastItem;
    }
  },
  computed: {
    formaterTitle(){
      return this.joinWithAnd(this.title);
    }
  }
}
